/* NAPPA PDP: gallery (counter/thumbs), review slider, load more, sticky ATC, every add -> NPA brand cart drawer (never /cart) */
(function () {
  var tr = document.querySelector('[data-npa-track]'), thumbs = document.querySelector('[data-npa-thumbs]'), cnt = document.querySelector('[data-npa-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('[data-npa-rs]').forEach(function (c) {
    var t = c.querySelector('.npa-rs__track');
    c.querySelectorAll('.npa-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });
  var more = document.querySelector('[data-npa-more]'), list = document.querySelector('[data-npa-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var form = document.getElementById('npa-buy');
  document.querySelectorAll('[data-npa-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var t = document.querySelector('.kaching-bundles') || form;
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    });
  });
  /* Kaching colour choice: no gallery jump (no per-colour images) */
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s || !s.closest || !s.closest('.kaching-bundles') || s.tagName !== 'SELECT') return;
    var t = (s.options[s.selectedIndex] || {}).text || '';
    void t;
  }, true);
  var st = document.querySelector('[data-npa-sticky]');
  if (st && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
  var sa = document.querySelector('[data-npa-sticky-atc]');
  if (sa && form) sa.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
  });
})();

/* Add to cart NEVER goes to /cart (Edvin 10-02): every /cart/add form opens the NPA brand cart drawer */
(function () {
  if (window.__npa_atc) return; window.__npa_atc = 1;
  function open() { if (window.NPA && window.NPA.openCart) return window.NPA.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 5) return setTimeout(add, 1000 * tries); if (b) b.disabled = false; open(); alert('Sorry, that did not go through - please tap Add to cart again.'); });
    })();
  }, false);
})();


/* NAPPA: Kaching bar label = "+ Mystery Gift · You save $14.85" (total saving of the bar), computed from the bar's own struck and sale price.
   Kaching's {{saved_amount}} is per clip, so without this script the label still reads correctly ("... per clip"). */
(function () {
  function num(s) {
    var m = (s || '').match(/\d[\d.,   ]*/); if (!m) return null;
    var t = m[0].replace(/[   ]/g, '').replace(/[.,]$/, ''), dec = 0, v;
    var last = Math.max(t.lastIndexOf('.'), t.lastIndexOf(','));
    if (last > -1 && t.length - last - 1 === 2) { dec = 2; v = parseFloat(t.slice(0, last).replace(/[.,]/g, '') + '.' + t.slice(last + 1)); }
    else v = parseFloat(t.replace(/[.,]/g, ''));
    return { v: v, dec: dec, raw: m[0], sep: last > -1 ? t.charAt(last) : '.' };
  }
  function fmt(price, d) {
    var p = num(price); if (!p) return null;
    var s = d.toFixed(p.dec);
    if (p.dec && p.sep === ',') s = s.replace('.', ',');
    var ip = s.split(/[.,]/)[0], rest = s.slice(ip.length), th = p.sep === ',' ? '.' : ',';
    if (ip.length > 3) ip = ip.replace(/\B(?=(\d{3})+(?!\d))/g, p.dec ? th : ',');
    return price.replace(p.raw.trim(), ip + rest);
  }
  function run() {
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (b) {
      var l = b.querySelector('.kaching-bundles__bar-label'), pe = b.querySelector('.kaching-bundles__bar-price'), fe = b.querySelector('.kaching-bundles__bar-full-price');
      if (!l || !pe || !fe) return;
      var p = num(pe.textContent), f = num(fe.textContent); if (!p || !f || !(f.v > p.v)) return;
      var fr = { V4: '+ Mystery Gift', V8: '+ Mystery Gift' }[b.getAttribute('data-deal-bar-id')];
      var txt = (fr ? fr + ' · ' : '') + 'You save ' + fmt(pe.textContent.trim(), Math.round((f.v - p.v) * 100) / 100);
      if (l.textContent !== txt) l.textContent = txt;
    });
  }
  var mo = new MutationObserver(function () { window.requestAnimationFrame(run); });
  function start() { run(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
